import { matchRoutes } from 'react-router-dom'
import {
  RequireAuth,
  RequireSubscribed,
  RequireGiftSubscription
} from './index'

// SPEC-095: the guards in routes.jsx are the one definition of which pages
// a logged-out visitor cannot stay on. These three send them away (to
// /login, the plans page, or /account → /login); the others only compare
// subscription state and keep logged-out visitors where they are.
const LOGIN_GUARDS = [RequireAuth, RequireSubscribed, RequireGiftSubscription]

// Guards nest (<RequireSubscribed><RequireNotLifetime>…), so walk the
// element chain down through single children.
const elementNeedsLogin = (element) => {
  let node = element
  while (node && typeof node === 'object') {
    if (LOGIN_GUARDS.includes(node.type)) return true
    const { children } = node.props || {}
    if (!children || Array.isArray(children)) return false
    node = children
  }
  return false
}

// The route pattern for a path (/lm/:slug, never the slug itself) and whether
// the visitor needs a login to stay on it.
export const routeAuthInfo = (pathname, routes) => {
  const matches = (routes && matchRoutes(routes, pathname)) || []
  const pattern = matches
    .map((m) => m.route.path)
    .filter(Boolean)
    .join('/')
  return {
    route: `/${pattern}`.replace(/\/+/g, '/'),
    authRequired: matches.some((m) => elementNeedsLogin(m.route.element))
  }
}

export default routeAuthInfo
